import {OwnerActionTypes, OwnerState} from './types'
import {action} from 'typesafe-actions'
import {EumYang} from '../../enums/EumYang'

export const changeSex = (sex: EumYang) =>
  action(OwnerActionTypes.CHANGE_SEX, {sex})
export const changeCalendar = (calendar: EumYang) =>
  action(OwnerActionTypes.CHANGE_CALENDAR, {calendar})
export const changeYear = (year: string) =>
  action(OwnerActionTypes.CHANGE_YEAR, {year})
export const changeMonth = (month: string) =>
  action(OwnerActionTypes.CHANGE_MONTH, {month})
export const changeDay = (day: string) =>
  action(OwnerActionTypes.CHANGE_DAY, {day})
export const changeHour = (hour: string) =>
  action(OwnerActionTypes.CHANGE_HOUR, {hour})
export const changeMinute = (minute: string) =>
  action(OwnerActionTypes.CHANGE_MINUTE, {minute})

export const changeIsLeapMonth = (isLeapMonth: boolean) =>
  action(OwnerActionTypes.CHANGE_IS_LEAPMONTH, {isLeapMonth})

export const changeFullOwnerState = (owner: OwnerState) =>
  action(OwnerActionTypes.CHANGE_FULL_STATE, {owner})
